// extracted by mini-css-extract-plugin
export default {"controls":"storage-controls_controls__A0vJT"};